import PropTypes from "prop-types";
import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { DialogModal } from "ui/dialog-modal";
import { Notification } from "ui/notification";

class AppCardLarge extends React.PureComponent {
  static get propTypes() {
    return {
      app: PropTypes.object.isRequired,
      editApp: PropTypes.func.isRequired,
      icon: PropTypes.string.isRequired,
      isAdmin: PropTypes.bool.isRequired,
    };
  }

  constructor(props) {
    super();

    this.state = {
      errorMessage: "",
      isUninstallModalOpen: false,
      submitted: false,
    };

    this.unavailableMsg =
      "This application is unavailable to your account. For example, " +
      "it has been archived or marked private by its owner.";

    this._install = this._install.bind(this);
    this._uninstall = this._uninstall.bind(this);
    this._hideUninstallModal = this._hideUninstallModal.bind(this);
    this._toggleUninstallModal = this._toggleUninstallModal.bind(this);
  }

  _getAuthor() {
    const { app } = this.props;
    if (app.is_own) {
      return "You";
    }

    return app.author;
  }

  _editApplication() {
    const { app, editApp } = this.props;
    const installed = app.is_installed;
    const owned = app.is_own;

    if (owned) {
      return null;
    }

    const serviceArgs = {
      id: app.id,
      operation: "install",
      isInstalled: !installed,
    };
    return editApp(serviceArgs).catch((e) => {
      this.setState({
        errorMessage: "Failed to edit the application. Please try again later.",
        submitted: false,
      });
    });
  }

  _install() {
    this.setState({ submitted: true }, this._editApplication);
  }

  _uninstall() {
    this.setState({ submitted: true }, () => {
      this._toggleUninstallModal();
      this._editApplication();
    });
  }

  _toggleUninstallModal() {
    this.setState((prevState) => {
      return {
        isUninstallModalOpen: !prevState.isUninstallModalOpen,
      };
    });
  }

  _hideUninstallModal() {
    this.setState({
      isUninstallModalOpen: false,
    });
  }

  _renderInstallButton() {
    const { app, isAdmin } = this.props;
    if (!isAdmin) {
      return null;
    }

    const { required, is_installed: isInstalled, is_own: owned } = app;

    if (owned || required) {
      return null;
    }

    const buttonAction = isInstalled
      ? this._toggleUninstallModal
      : this._install;

    return (
      <Button
        size="sm"
        variant={isInstalled ? "default" : "primary"}
        onClick={buttonAction}
      >
        {isInstalled ? "Uninstall" : "Install"}
      </Button>
    );
  }

  _renderUninstallModal() {
    if (!this.state.isUninstallModalOpen) {
      return null;
    }

    const title = <strong>Are you sure you want to uninstall this app?</strong>;

    return (
      <DialogModal
        btnStyle="danger"
        title={title}
        desc="This may affect Fleet or device functionality."
        onHide={this._hideUninstallModal}
        onSuccess={this._uninstall}
        buttonLabel="Uninstall"
      />
    );
  }

  render() {
    const { app, icon } = this.props;
    const { errorMessage } = this.state;
    if (!app || app.hide_on_ui) {
      return null;
    }

    const {
      available,
      id,
      stable_version: stableVersion,
      display_name: displayName,
    } = app;
    const author = this._getAuthor();

    const url = stableVersion
      ? `/applications/${id}`
      : `/applications/${id}/testing`;

    const availableClass = available ? "available" : "unavailable";
    const cardClass =
      "box box-widget widget-user-2 app-card-large " + availableClass;
    const title = available ? undefined : this.unavailableMsg;

    return (
      <div className={cardClass} title={title}>
        <Link to={url}>
          <div className="widget-user-header bg-white app-card-header">
            <img src={icon} alt={app.name} />
          </div>
        </Link>
        <div className="box-footer no-padding app-card-footer">
          <h4>{displayName}</h4>
          <h5 className="app-author">by {author}</h5>
          {!available && (
            <h5 className="app-unavailable">
              <small>App Unavailable.</small>
            </h5>
          )}
          {this._renderInstallButton()}
          <Notification error={errorMessage} />
          {this._renderUninstallModal()}
        </div>
      </div>
    );
  }
}

export { AppCardLarge };
